import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from '../schema';

const MUTATION = gql`
  mutation UpdateExpertMultiPromptTemplate(
    $id: ID!
    $templateGroup: TemplateGroupEnum!
    $tags: [TemplateTagEnum!]
    $smallImage: String
    $bigImage: String
    $iconImage: String
    $wideImage: String
  ) {
    updateExpertMultiPromptTemplate(
      id: $id
      templateGroup: $templateGroup
      tags: $tags
      smallImage: $smallImage
      bigImage: $bigImage
      iconImage: $iconImage
      wideImage: $wideImage
    ) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

export const updateExpertMultiPromptTemplate = async ({
  id,
  templateGroup,
  tags,
  smallImage,
  bigImage,
  iconImage,
  wideImage,
}) => {
  const variables = {
    id,
    templateGroup,
    tags,
    smallImage,
    bigImage,
    iconImage,
    wideImage,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
